import { render, staticRenderFns } from "./VentasAcumulado.vue?vue&type=template&id=3de00665&"
import script from "./VentasAcumulado.vue?vue&type=script&lang=js&"
export * from "./VentasAcumulado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports